import { ReactElement } from 'react';

export interface InputProps {
  name: string;
  config: {
    typeNumber?: string;
    name: string;
    nameSelect?: string;
    status?: string;
    message?: string;
    bodyRequest?: object;
    options?: {
      value: string;
      label: string;
    }[];
  };
  isMulti?: boolean;
  component?: ReactElement;
}

export const CONTENT = 'content';
export const SELECT = 'select';
export const MULTI_SELECT = 'multi-select';
export const MULTI_CHECK = 'multi-check';
export const IDENTIFICATION = 'identification';
export const DATE_RANGE = 'date-range';
export const DATE = 'date';
export const EMAIL = 'email';
export const SELECT_PATIENT = 'select-patient';
export const SELECT_USER = 'select-user';
export const INPUT = 'input';
export const SELECT_DATA_IN_EXAMS = 'select-data-in-exams';
export const SELECT_OBJECT_IN_EXAMS = 'select-object-in-exams';

export default {
  MULTI_SELECT,
  MULTI_CHECK,
  IDENTIFICATION,
  DATE_RANGE,
  DATE,
  SELECT_PATIENT,
  SELECT_USER,
  SELECT_DATA_IN_EXAMS,
  SELECT_OBJECT_IN_EXAMS,
  CONTENT
};
